/**
 * @generated SignedSource<<d6f4da6c19f2fcd186037422827e4334>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResetPasswordAndActivateInput = {
  clientMutationId?: string | null;
  newPassword: string;
  token: string;
};
export type useAuthContext_ResetPasswordMutation$variables = {
  input: ResetPasswordAndActivateInput;
};
export type useAuthContext_ResetPasswordMutation$data = {
  readonly Auth: {
    readonly resetPasswordAndActivate: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type useAuthContext_ResetPasswordMutation = {
  response: useAuthContext_ResetPasswordMutation$data;
  variables: useAuthContext_ResetPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ResetPasswordAndActivatePayload",
        "kind": "LinkedField",
        "name": "resetPasswordAndActivate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_ResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_ResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f53d751660166098819421058caa9ad",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_ResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_ResetPasswordMutation(\n  $input: ResetPasswordAndActivateInput!\n) {\n  Auth {\n    resetPasswordAndActivate(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "193b4e40e78d2bbbcbdb54d86db2f866";

export default node;
